import fetch from 'scripts/utils/_fetch'

const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/wishlists`

export const lists = () =>
  fetch.get(endpoint)

export const ids = () =>
  fetch.get(`${endpoint}/ids`)

export const createList = data =>
  fetch.post(endpoint, { body: data })

export const editList = (data, slug) =>
  fetch.put(`${endpoint}/${slug}`, { body: data })

export const getList = (slug) =>
  fetch.get(`${endpoint}/${slug}`)

export const removeList = slug =>
  fetch.delete(`${endpoint}/${slug}`)

export const isOnWishlist = id =>
  fetch.get(`${endpoint}/product/${id}`)

export const removeProductFromLists = id =>
  fetch.delete(`${endpoint}/product/${id}`)

export const addProduct = (slug, data) =>
  fetch.post(`${endpoint}/${slug}/product`, { body: data })

export const removeProduct = (slug, id) =>
  fetch.delete(`${endpoint}/${slug}/product/${id}`)

export const addContent = (slug, id) =>
  fetch.post(`${endpoint}/${slug}/content/${id}`)

export const removeContentFromLists = id =>
  fetch.delete(`${endpoint}/content/${id}`)
